import { css } from "@stubhub/broadway-foundation/css";

export const linksHeaderWrapper = css({
  marginBlockEnd: "primitives.150",
});

export const linksGrid = css({
  display: "grid",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
  gridTemplateColumns: "1fr",
  tablet: {
    gridTemplateColumns: "1fr 1fr",
  },
  desktop: {
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
  },
});

export const linkItemContainer = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minWidth: "primitives.0",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
  paddingBlockStart: "primitives.200",
  paddingBlockEnd: "primitives.200",
  paddingInlineStart: "primitives.200",
  paddingInlineEnd: "primitives.200",
  borderStartStartRadius: "element.small",
  borderStartEndRadius: "element.small",
  borderEndStartRadius: "element.small",
  borderEndEndRadius: "element.small",
  borderBlockStartWidth: "primitives.25",
  borderBlockEndWidth: "primitives.25",
  borderInlineStartWidth: "primitives.25",
  borderInlineEndWidth: "primitives.25",
  borderBlockStartStyle: "solid",
  borderBlockEndStyle: "solid",
  borderInlineStartStyle: "solid",
  borderInlineEndStyle: "solid",
  borderBlockStartColor: "border",
  borderBlockEndColor: "border",
  borderInlineStartColor: "border",
  borderInlineEndColor: "border",
  backgroundColor: "bg.surface",
  _hover: {
    backgroundColor: "bg.surface.stronger.hover",
  },
  _active: {
    backgroundColor: "bg.surface.stronger.active",
  },
});
export const linkItemLocation = css({
  display: "flex",
  flexDirection: "column",
  width: "[calc(100% - {spacing.primitives.300})]",
});
export const linkItemStateProvinceName = css({
  color: "text.subtle",
});
